export default "__VITE_ASSET__B817xr_T__"